import React, { useState, useCallback } from "react";
import VsiAlert from "../../components/VsiAlert";

import { createPortal } from "react-dom";

let _showAlert;

const divContainerStyle = {
  position: "fixed",
  top: 10,
  left: 0,
  right: 0,
  zIndex: 10000,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px"
};

export const AlertProvider = () => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback((msg, type = "success") => {
    const id = Date.now();
    setAlerts(prev => [...prev, { id, msg, type, isOpen: true }]);
    setTimeout(() => closeAlert(id), 3000);
  }, [setAlerts]);

  const closeAlert = useCallback((id) => {
    setAlerts(prev => prev.map(a => (a.id === id ? { ...a, isOpen: false } : a)));
    setTimeout(() => {
      setAlerts(prev => prev.filter(a => a.id !== id));
    }, 400);
  }, [setAlerts]);

  // expose globally oh my
  _showAlert = showAlert;

  // type is "danger" or "success", but should probably be modified to have warning also
  return createPortal(
    <div style={divContainerStyle}>
      {alerts.map(a => (
        <VsiAlert
          key={a.id}
          color={a.type}
          isOpen={a.isOpen}
          toggle={() => closeAlert(a.id)}
        >
          {a.msg}
        </VsiAlert>
      ))}
    </div>,
    document.body
  );

};

export const showAlert = (...args) => {
  if (_showAlert) _showAlert(...args);
};